<ppl-auth-message [showIcon]="false"
                  label="Sign In Is Completed"
                  i18n-label="@@Sign_In_Is_Completed"
                  message="You can close this dialog box and continue working."
                  i18n-message="@@You_can_close_this_dialog_box_and_continue_working."
                  actionLabel="Continue to application"
                  i18n-actionLabel="@@Continue_to_application"
                  (action)="onAction()"></ppl-auth-message>
